import React from 'react';
import PropTypes from 'prop-types';

import { Pill } from '../../../Pill/Pill';
import { getOrderStatusLabel, financialStatuses } from '../../Account.utils';

/**
 * A Pill that displays the status of an Order
 */
const OrderStatusPill = ({
  fulfillmentStatus,
  financialStatus,
  canceledAt
}) => (
  <Pill
    label={getOrderStatusLabel(fulfillmentStatus, financialStatus, canceledAt)}
    variant={
      financialStatuses[financialStatus] || canceledAt ? 'error' : 'dark'
    }
  />
);

OrderStatusPill.propTypes = {
  financialStatus: PropTypes.string,
  fulfillmentStatus: PropTypes.oneOf([
    'FULFILLED',
    'IN_PROGRESS',
    'OPEN',
    'PARTIALLY_FULFILLED',
    'PENDING_FULFILLMENT',
    'RESTOCKED',
    'SCHEDULED',
    'UNFULFILLED'
  ]).isRequired,
  canceledAt: PropTypes.oneOfType([
    (props, propName, componentName) => {
      if (
        !/^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i.test(
          props[propName]
        )
      ) {
        return new Error(
          `Invalid prop \`${propName}\` passed to \`${componentName}\`. Expected a ISO8601 string.`
        );
      }
    }
  ])
};

OrderStatusPill.defaultProps = {
  canceledAt: null,
  financialStatus: null
};

export default OrderStatusPill;
